<template>
    <ul role="list" class="divide-y divide-gray-100">
        <li
            v-for="chat in recentChats"
            :key="chat.id"
            class="relative flex justify-between gap-x-6 px-4 py-5 hover:bg-gray-50 sm:px-6 lg:px-8"
        >
            <div class="flex min-w-0 gap-x-4">
                <img
                    v-if="chat.imageUrl"
                    class="h-12 w-12 flex-none rounded-full bg-gray-50"
                    :src="person.imageUrl"
                    alt=""
                />
                <div class="min-w-0 flex-auto">
                    <p class="text-sm font-semibold leading-6 text-gray-900">
                        <a :href="sanitizeUriWithParams('/chat/' + chat.id)">
                            <span class="absolute inset-x-0 -top-px bottom-0" />
                            {{ chat.title || placeholderTitle }}
                        </a>
                    </p>
                    <p class="mt-1 flex text-xs leading-5 text-gray-500">
                        <a
                            :href="sanitizeUriWithParams('/chat/' + chat.id)"
                            class="relative hover:underline"
                            >{{ chat.description || placeholderDescription }}</a
                        >
                    </p>
                    <p
                        class="sm:hidden mt-4 flex text-xs leading-5 text-gray-500"
                    >
                        {{ formatDate(chat.updated_at) }}
                    </p>
                </div>
            </div>
            <div class="flex shrink-0 items-center gap-x-4">
                <div class="hidden sm:flex sm:flex-col sm:items-end">
                    <p
                        v-if="chat.updated_at"
                        class="mt-1 text-xs leading-5 text-gray-500"
                    >
                        {{ formatDate(chat.updated_at) }}
                    </p>
                </div>
                <ChevronRightIcon
                    class="h-5 w-5 flex-none text-gray-400"
                    aria-hidden="true"
                />
            </div>
        </li>
    </ul>
</template>

<script setup lang="ts">
import moment from "moment";
import { ChevronRightIcon } from "@heroicons/vue/20/solid";
import { useCourse } from "@/composables/course";
import { useGeneral } from "@/composables/general";
const { widgetConfig } = useCourse();
const { sanitizeUriWithParams } = useGeneral();
const props = defineProps(["recentChats"]);
const formatDate = (date: string) => {
    const fromNow = moment(date).fromNow();
    console.log(fromNow);
    return fromNow;
};
const isTurno = computed(() => {
    return widgetConfig?.value?.platform === "turnoai";
});
const placeholderTitle = isTurno.value
    ? "AI Assistant"
    : "Golf Course Booking Assistant";
const placeholderDescription = isTurno.value
    ? "A conversation with a customer with the AI Assistant"
    : "A conversation with a customer with the Golf Course Booking Assistant";
</script>
